<div [formGroup]="form">
    <ckeditor [editor]="editor" [config]="ckeditorConfig" [formControlName]="'content'"></ckeditor>
</div>
